import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { CountryLegacy, CountryLegacyService as SDKCountryLegacy } from '@adeo/ngx-kozikaza-api/misc/country-legacy';

@Injectable()
export class CountriesResolver  {
  constructor(
    private readonly sdkCountryLegacyService: SDKCountryLegacy
  ) {}

  resolve(): Observable<CountryLegacy[]> {
    return this.sdkCountryLegacyService.getCountries();
  }
}
